import React, { Component } from 'react';
import WhiteLayout from '../template/WhiteLayout';

export default class PageNotFound extends Component {
	render() {
		return (
			<WhiteLayout>
				<React.Fragment>
					<div className="error-page">
						<h2 className="headline text-yellow">404</h2>

						<div className="error-content">
							<h3>
								<i className="fa fa-warning text-yellow" /> Ops! Página não encontrada.
							</h3>
							<p>
								retorne para o <a href="/home">dashboard</a> ou tente outra página de sua preferência.
							</p>
						</div>
					</div>
				</React.Fragment>
			</WhiteLayout>
		);
	}
}
